import StringUtil from "utils/StringUtil";

import IValidationRule from "./ValidationRule";

export default class ValidationRuleBytes implements IValidationRule {
  private static readonly UNICODE_CHAR_SIZE: number = 1;

  private _message: string | undefined;
  private _inform: string | undefined;
  private _props: ValidationRuleBytesProps;

  constructor(_props: ValidationRuleBytesProps) {
    this._props = _props;
  }

  public get message(): string | undefined {
    return this._message;
  }

  public get inform(): string | undefined {
    return this._inform;
  }

  public check(value: any): boolean {
    this._message = undefined;

    if (value == null) {
      value = "";
    }

    let inputByte: number = 0;

    for (let i = 0; i < value.length; i++) {
      inputByte += value.charCodeAt(i) <= 128 ? 1 : this._props.unicodeCharSize || ValidationRuleBytes.UNICODE_CHAR_SIZE;
    }

    const formatMinByte = StringUtil.formatNumber(String(this._props.minByte));
    const formatMaxByte = StringUtil.formatNumber(String(this._props.maxByte));
    const formatInputByte = StringUtil.formatNumber(String(inputByte));

    if (this._props.messaging === true) {
      this._inform = `<span style="color: #0000ff;">${formatInputByte} Bytes</span> / ${formatMaxByte} Bytes`;
    }

    if (this._props.minByte != null && inputByte < this._props.minByte) {
      this._message = `최소 글자수(${formatMinByte} Bytes): ${formatInputByte} Bytes`;

      return false;
    }

    if (this._props.maxByte != null && inputByte > this._props.maxByte) {
      this._message = `허용 글자수(${formatMaxByte} Bytes) 초과 : ${formatInputByte} Bytes`;

      return false;
    }

    return true;
  }
}

export interface ValidationRuleBytesProps {
  minByte?: number;
  maxByte?: number;
  unicodeCharSize?: number;
  messaging?: boolean;
}
